<template>
    <dropdown-cart :display="display" :displayMedia="displayMedia" class="cart-dropdown">
        <a href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
            <i :class="cart_icon_class"></i>
            <h3 v-if="activeIconCartCircle">Carrinho</h3>
            <span class="cart-count">
                {{ itemsCart.totalItems ? itemsCart.totalItems : ' 0' }}
                <span v-if="activeIconCartCircle">
                    &nbsp;{{ itemsCart.totalItems > 1 ? 'itens' : 'item' }} ({{ currency.money(itemsCart.subTotal) }})
                </span>
            </span>
        </a>
        <dropdown-menu :cartLeft="cart_left">
            <dropdown-menu-wrapper v-if="hidePrice == false">
                <dropdown-cart-header>
                    <span v-html="totalItemsDesc"></span>
                    <a href="#" v-if="itemsCart.totalItems > 0">{{ currency.money(itemsCart.subTotal) }}</a>
                </dropdown-cart-header>
                <dropdown-cart-products class="dropdown-cart-products">
                    <!-- LISTAGEM DE PRODUTOS SIMPLES -->
                    <template v-for="item in itemsCart.list">
                        <div :key="item.key_loop" v-if="!item.is_product_group && !item.has_childs_additionals && !item.additional_product && !item.uuid_item_father_cart">
                            <CartProduct
                                :product="item"
                                @removeProduct="removeItem"
                            />
                        </div>
                    </template>

                    <!-- LISTAGEM DE PRODUTOS DE CESTA -->
                    <template v-if="itemsCart.father_list">
                        <div v-for="item in itemsCart.father_list" :key="item.key_loop">
                            <CartProduct
                                :product="item"
                                :children="item.children"
                                @removeProduct="removeProductGroup($event, item.children)"
                            />
                        </div>
                    </template>

                    <!-- LISTAGEM DE PRODUTOS COM ADICIONAIS -->
                    <template v-if="listCartWithAdditionalProducts">
                        <div v-for="item in listCartWithAdditionalProducts" :key="item.key_loop">
                            <CartProduct
                                :product="item"
                                :children="item.additional_products[0]"
                                @removeProduct="removeItem"
                            />
                        </div>
                    </template>
                </dropdown-cart-products>
                <dropdown-cart-actions class="dropdown-cart-action">
                    <div v-if="itemsCart.totalItems > 0" class="dropdown-cart-clean-cart">
                        <span @click="handleCleanCart">
                            {{ isBudgetLayout ? 'Limpar Orçamento' : 'Limpar Carrinho' }}
                        </span>
                    </div>
                    

                    <c-ancora
                        :backgroundColor="$root.$children[0].theme.products.button.background_color"
                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                        :borderColor="$root.$children[0].theme.products.button.border_color"
                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                        :textTransform="$root.$children[0].theme.products.button.text_transform"
                        padding=".85rem 2rem"
                        :fontSize="$root.$children[0].theme.font_size_button"
                        height="unset"
                        :href="openCartPage == true ? $baseUrl+'cart' :  $baseUrl+'checkout'"
                        class="btn-block"
                    >
                        {{ isBudgetLayout ? 'Orçamento' : 'Carrinho' }}
                    </c-ancora>
                </dropdown-cart-actions>
            </dropdown-menu-wrapper>
            <dropdown-menu-wrapper v-else>
                <c-span style="font-size: 1.5rem; display: inline-block; margin: 0.5rem 0">
                    Faça login para ter acesso ao carrinho, clicando no botão abaixo.
                </c-span><br>
                <c-ancora
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :href="$baseUrl+'login'"
                    padding="0.85rem 2.5rem"
                    class="mt-1 mb-1 btn-block"
                    title="Entrar"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                        Entrar
                    </span>
                </c-ancora>
            </dropdown-menu-wrapper>
        </dropdown-menu>
    </dropdown-cart>
</template>

<script>
import {
    CDropdownCart,
    CDropdownMenu,
    CDropdownCartHeader,
    CDropdownMenuWrapper,
    CDropdownCartProducts,
    CDropdownCartActions
} from '../Styles/Dropdown/styled'
import {CAncora} from '../../components/Styles/Button/styled'
import {mapActions, mapGetters, mapState} from 'vuex'
import Currency from '../../helpers/parseCurrency'
import { CSpan } from '../Styles/Components/styled'
import { getListEmployeeTypes } from '../../modules/clients/store/actions'
import CartProduct from './CartProduct'
import { swall } from '../../services/sweetAlert'

export default {
    name: 'DropDownCart',
    props: {
        display: {
            default: 'block',
            type: String
        },
        displayMedia: {
            default: 'none',
            type: String
        },
        show_code_original_beside_description: {
            default: false
        },
        cart_left: {
            default: false
        }
    },
    components: {
        'dropdown-cart' : CDropdownCart,
        'dropdown-menu': CDropdownMenu,
        'dropdown-menu-wrapper' : CDropdownMenuWrapper,
        'dropdown-cart-header' : CDropdownCartHeader,
        'c-ancora': CAncora,
        'dropdown-cart-products': CDropdownCartProducts,
        'dropdown-cart-actions': CDropdownCartActions,
        'c-span': CSpan,
        CartProduct,
    },
    data() {
        return {
            currency: Currency,
            totalItemsDesc: "",
            textTransform: this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? '',
            company: this.$root.$children[0].$attrs.company,
        }
    },
    mounted() {
        this.callGetItemsCart && this.getItemsCart()
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart",
            "ActionGetItemsCart",
            "ActionRemoveItemCart",
            "ActionSetCalledGetItemsCart",
            "ActionRemoveProductGroup",
            "ActionDestroyCart",
        ]),
        handleCleanCart() {
            this.isLoading = true
             this.$swal({
                        title: `<p style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 500;">
                             ${this.isBudgetLayout ? 'Tem certeza que deseja limpar o orçamento?' : 'Tem certeza que deseja limpar o carrinho?'}
                            </p>`,
                        icon: 'warning',
                        showCancelButton: true,
                        background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                        confirmButtonText: `<span style="font-size: 1.8rem; font-weight: 600">sim, limpar!</span>`,
                        confirmButtonColor: "#000",
                        cancelButtonColor: '#d33',
                        cancelButtonText: `<span style="font-size: 1.8rem; font-weight: 600">Cancelar</span>`,
                        allowEscapeKey: false,
                        allowOutsideClick: true
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.isLoading = true
                            this.ActionDestroyCart()
                                .then((resp) => {
                                    this.isLoading = false
                                    let {data} = resp
                                    this.ActionSetItemsCart(data)
                                })
                                .catch((error) => {
                                    this.isLoading = false
                                    swall(error?.msg ?? error?.message ?? error)
                            })
                        }
                    })
          
        },
        async getItemsCart() {
            this.ActionSetCalledGetItemsCart(true)
            await this.ActionGetItemsCart()
            .then((resp) => {
                let { data } = resp
                this.ActionSetItemsCart(data)
                // if(this.containsAdditionalProductsInCart){
                //    console.log(this.listCartWithAdditionalProducts)
                // }
            })
            .catch((error) => {
                if(error.msg) {
                    console.log('ERROR GET ITEMS CART: '+error.msg)
                    return
                }
                console.log('ERROR GET ITEMS CART: '+error)
            })
        },
        removeItem(item) {
            let data = {
                pro_id: item.id,
                key: item.key_cart
            }
            this.ActionRemoveItemCart(data)
            .then((resp) => {
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        removeProductGroup(item, children) {
            let children_uuids = []
            for (const i in children) {
                if (Object.hasOwnProperty.call(children, i)) {
                    const element = children[i];
                    children_uuids.push(element.uuid)
                }
            }
            let body = {
                father_uuid: item.uuid,
                children_uuids
            }
            this.ActionRemoveProductGroup(body)
             .then((resp) => {
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        formatTotalItems(totalItems) {

            if (totalItems <= 0) {
                if (this.isBudgetLayout) {
                    this.totalItemsDesc = "Orçamento Vazio"
                } else {
                    this.totalItemsDesc = "Carrinho Vazio"
                }
            }
            if (totalItems == 1) {
                this.totalItemsDesc = totalItems+" produto"
                return
            }
            if (totalItems > 1) {
                this.totalItemsDesc = totalItems+" produtos"
                return
            }
        },
    },
    watch: {
        /**preciso de watych no list */
        itemsCart(data) {
            if(!data) {
                return
            }

            this.formatTotalItems(data.totalItems)
            data.list.forEach(element => {
                element.pro_name_site = this.textTransform == 'uppercase' ? element.pro_name_site.toUpperCase() :
                    this.textTransform == 'lowercase' ? element.pro_name_site.toLowerCase() :
                    this.textTransform == 'initial' ? (element.pro_name_site[0].toUpperCase() + element.pro_name_site.substr(1).toLowerCase()) :
                    this.textTransform == 'capitalize' ? (element.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })): element.pro_name_site
            });
        },
    },
    computed: {
        ...mapState("cart", ["itemsCart", "listCartWithAdditionalProducts"]),
        ...mapGetters("cart", [
            "callGetItemsCart",
            "containsAdditionalProductsInCart"
        ]),
        ...mapGetters("company", ["getShowUnitOfMeasureInProductPrice"]),
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        cart_icon_class() {
            return this.$root.$children[0].theme?.cart_icon_class ?? 'icon-cart'
        },
        activeIconCartCircle() {
            return this.$root.$children[0].theme?.header?.active_icon_cart_circle ?? false
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        openCartPage() {
            return this.$root.$children[0].theme?.cart.open_cart_page ?? true
        }
    }
}
</script>
